import { Box, Button, ButtonGroup, Card, Stack, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PageHeader } from '../../../app/AppStyles';
import { fetchSchoolclassGroup, fetchSchoolclassGroups, postSchoolclassGroup, putSchoolclassGroup, resetSchoolclassGroupStatus } from './schoolclassGroupSlice';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    width: { xs: '90%', md: '40%' },
    maxHeight: '90%',
    boxShadow: 24,
};

export default function SchoolclassGroupEditCard({ handleClose, addNew, schoolclassGroupId }) {
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.user);
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { schoolclassGroup, schoolclassGroupsPost, schoolclassGroupsPut } = useSelector((state) => state.management.schoolclassGroup);

    const [changed, setChanged] = useState(false);
    const [newSchoolclassGroup, setNewSchoolclassGroup] = useState({});

    // Put status callback
    useEffect(() => {
        if (schoolclassGroupsPut.status === "success") {
            dispatch(resetSchoolclassGroupStatus());
            dispatch(fetchSchoolclassGroup(schoolclassGroupId));
            handleClose();
        } else if (schoolclassGroupsPut.status === "failed") {
            dispatch(resetSchoolclassGroupStatus());
        };
    }, [dispatch, handleClose, schoolclassGroupsPut.status]);

    // Post status callback
    useEffect(() => {
        if (schoolclassGroupsPost.status === "success") {
            dispatch(resetSchoolclassGroupStatus());
            dispatch(fetchSchoolclassGroups());
            handleClose();
        } else if (schoolclassGroupsPost.status === "failed") {
            dispatch(resetSchoolclassGroupStatus());
        };
    }, [dispatch, handleClose, schoolclassGroupsPost.status]);

    // Selected period state update 
    useEffect(() => {
        if (!addNew && schoolclassGroup.data) {
            setNewSchoolclassGroup(schoolclassGroup.data);
        }
    }, [schoolclassGroup.data, addNew]);

    // Keep track of changed state 
    useEffect(() => {
        if (newSchoolclassGroup !== schoolclassGroup.data) {
            setChanged(true);
        } else {
            setChanged(false);
        };
    }, [schoolclassGroup.data, newSchoolclassGroup]);

    // Update click function (check property character limits etc.)
    const updateClick = () => {
        let tempObject = { ...newSchoolclassGroup }; // Needed to circumvent weird read only property error

        tempObject.createdBy = `AP/${user.number}`;

        dispatch(putSchoolclassGroup(tempObject));
    };

    // Add click function (check property character limits etc.)
    const addClick = () => {
        let tempObject = { ...newSchoolclassGroup }; // Needed to circumvent weird read only property error

        tempObject.createdBy = `AP/${user.number}`;

        dispatch(postSchoolclassGroup(tempObject));
    };

    return (
        <Box sx={{ ...modalStyle }}>
            <Card sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto', p: 2 }}>
                <Stack spacing={1} sx={{ flex: '1 1 auto' }}>
                    <Typography variant="h6" sx={{ ...PageHeader }}>{resourceFinal[appLanguage].words.CLASS} {addNew ? resourceFinal[appLanguage].words.ADD.toLowerCase() : resourceFinal[appLanguage].words.EDIT.toLowerCase()}</Typography>
                    <TextField
                        fullWidth required
                        defaultValue={schoolclassGroup.data?.schoolclassGroupName}
                        label={resourceFinal[appLanguage].words.NAME}
                        onChange={(event) => setNewSchoolclassGroup({
                            ...newSchoolclassGroup,
                            schoolclassGroupName: event.target.value
                        })}
                        variant="outlined"
                    />
                    <TextField
                        fullWidth multiline
                        defaultValue={schoolclassGroup.data?.schoolclassGroupDescription}
                        label={resourceFinal[appLanguage].words.DESCRIPTION}
                        onChange={(event) => setNewSchoolclassGroup({
                            ...newSchoolclassGroup,
                            schoolclassGroupDescription: event.target.value
                        })}
                        variant="outlined"
                    />

                    {(schoolclassGroupsPost.data === false || schoolclassGroupsPut.data === false) && <>
                        <Typography variant="body1" color="error" sx={{ textAlign: 'center' }}>{resourceFinal[appLanguage].messages.ERROR_SAVE_FAILED}</Typography>
                    </>}

                    <ButtonGroup sx={{ justifyContent: 'center' }}>
                        <Button variant="outlined" color="error" onClick={handleClose}>{resourceFinal[appLanguage].words.CANCEL}</Button>
                        {!addNew && <Button disabled={!changed} variant="outlined" color="primary" onClick={updateClick}>{resourceFinal[appLanguage].words.SAVE}</Button>}
                        {addNew && <Button variant="outlined" color="primary" onClick={addClick}>{resourceFinal[appLanguage].words.ADD}</Button>}
                    </ButtonGroup>
                </Stack>
            </Card>
        </Box>
    );
}
